import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ModalService } from '../../../services/modal.service';
import { IMessengerConnector } from '../../../types/all.type';

@Component({
  selector: 'app-avatar-user',
  templateUrl: './avatar-user.component.html',
  styleUrls: ['./avatar-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarUserComponent implements OnInit {
  @Input() user: any;
  @Input() Service: IMessengerConnector;
  constructor(public modalService: ModalService) {}

  ngOnInit(): void {
    //this.cd.detach();
    //this.cd.detectChanges();
  }
  openDetailInfo(id) {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id: id,
      type: 'user'
    });
  }
}
